import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { ProductRelease } from '../../lib/productUpdates';

// A release as a dateline, its one-line summary, and its highlights two to a row.
export default function ReleaseNotes({ release }: { release: ProductRelease }) {
  return (
    <article className="space-y-6">
      <p className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.08em] text-vein-red-600">
        <SparklesIcon className="w-4 h-4" aria-hidden="true" />
        What’s new ·{' '}
        <time dateTime={release.publishedAt}>
          {new Date(release.publishedAt).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
        </time>
      </p>
      <p className="-mt-3 text-[15px] text-gray-700">{release.summary}</p>
      {release.highlights.length > 0 && (
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-6">
          {release.highlights.map(({ title, description }) => (
            <li key={title}>
              <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
              <p className="text-sm text-gray-600 mt-1 leading-relaxed">{description}</p>
            </li>
          ))}
        </ul>
      )}
    </article>
  );
}
